enum GENERAL_ROUTES {
  HOME = '/',
  BASKET = '/baskets/basket',
  LIST = '/list'
}

enum AUTH_ROUTES {
  AUTH = '/users/auth',
  LOGIN = '/users/auth/login',
  REGISTER = '/users/auth/register',
  FORGOT_PASSWORD = '/users/password/reset',
  EMAIL_SET_PRIMARY = '/users/email-set-primary/.+',
  CONFIRM_EMAIL = '/users/registration/account-confirm-email/.+',
  AKIFAST = 'https://oauth.akifast.com/login'
}

enum ACCOUNT_ROUTES {
  ACCOUNT = '/account',
  ACCOUNT_ADDRESS = '/account/address',
  ACCOUNT_CHANGE_EMAIL = '/account/change-email',
  ACCOUNT_CHANGE_PASSWORD = '/account/change-password',
  ACCOUNT_CONTACT = '/account/contact',
  ACCOUNT_COUPONS = '/account/coupons',
  ACCOUNT_NOTIFICATION_SETTINGS = '/account/notification-settings',
  ACCOUNT_LOYALTY = '/account/loyalty',
  ACCOUNT_FAQ = '/account/faq',
  ACCOUNT_ORDERS = '/users/orders',
  ACCOUNT_OLD_ORDERS = '/users/old-orders',
  ACCOUNT_OLD_ORDERS_DETAIL = '/users/old-orders/(?<orderPk>[0-9]+)',
  ACCOUNT_ORDERS_CANCELLATION = '/users/orders/(?<orderPk>[0-9]+)/cancellation',
  ACCOUNT_PROFILE = '/account/profile',
  ACCOUNT_WISHLIST = '/account/favourite-products/',
  ACCOUNT_COLLECTIONS = '/account/collections/',
  ANONYMOUS_TRACKING = '/uyeliksiz-siparis-takibi'
}

enum ORDER_ROUTES {
  CHECKOUT = '/orders/checkout',
  CHECKOUT_COMPLETED = '/orders/completed',
  GARANTI_PAY_REDIRECT = '/orders/garanti-pay-redirect'
}

enum FLATPAGE_ROUTES {
  CONTACT_US = '/contact-us'
}

enum PRODUCT_ROUTES {}

export const ROUTES = {
  ...GENERAL_ROUTES,
  ...AUTH_ROUTES,
  ...ACCOUNT_ROUTES,
  ...ORDER_ROUTES,
  ...FLATPAGE_ROUTES,
  ...PRODUCT_ROUTES
};
